import Link from "next/link";

/** Link to collection details without crowding compact forms.
 *
 * Place this beside the initial submission control, where visitors provide
 * their email or broader inquiry details. */
export function PrivacyNotice({
  subject,
  className = "",
}: {
  subject: "email" | "details";
  className?: string;
}) {
  return (
    <div className={`small text-body-secondary mt-2 ${className}`}>
      How we use your {subject}: <Link prefetch={false} href="/docs/privacy/">privacy policy</Link>.
    </div>
  );
}
